import React from 'react';

import { Icon } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { RedeemRewardActionButtonProps, RewardActions } from './types';

export const RedeemRewardActionButton = ({
  action,
  disabled,
  onRewardAdd,
  onRewardRemove,
  points,
  locked,
  loading,
}: RedeemRewardActionButtonProps) => {
  const isAdd = action === RewardActions.ADD;

  const buttonStyles = {
    backgroundColor: disabled
      ? primitive.$white
      : isAdd
      ? primitive.$meltyYellow
      : primitive.$white,
    textColor: disabled ? primitive.$blackOpacity50 : primitive.$bbqBrown,
    variant: disabled
      ? ActionButtonVariants.OUTLINE
      : isAdd
      ? ActionButtonVariants.PRIMARY
      : ActionButtonVariants.OUTLINE,
    borderColor: disabled ? primitive.$blackOpacity50 : isAdd ? '' : primitive.$bbqBrown,
  };

  const { backgroundColor, textColor, variant, borderColor } = buttonStyles;
  const buttonText = String(locked ? points : isAdd ? t('redeemApply', { points }) : points);

  const redeemKey = isAdd ? 'redeemApply' : 'redeemRemove';
  const accessibilityLabel = `${t(redeemKey, { points })} ${t('crowns')} `;

  return (
    <ActionButton
      variant={variant}
      size={ActionButtonSizes.SMALL}
      disabled={disabled}
      onPress={isAdd ? onRewardAdd : onRewardRemove}
      testID={`redeem-${isAdd ? 'add' : 'remove'}`}
      background={backgroundColor}
      isLoading={loading}
      accessibilityLabel={accessibilityLabel}
      borderColor={borderColor}
      _hover={{ borderColor }}
      _pressed={{ borderColor }}
      _text={{
        color: textColor,
        fontSize: 'xs',
        lineHeight: 'xs',
      }}
      keepIconSize
      leftIcon={isAdd ? undefined : <Icon color={primitive.$black} variant="cancel" size="xs" />}
      rightIcon={
        loading ? undefined : (
          <LoyaltyPointsIcon
            width="15px"
            height="15px"
            fill={disabled ? primitive.$blackOpacity50 : isAdd ? textColor : primitive.$meltyYellow}
          />
        )
      }
      _spinner={{
        height: spacing.$3_5,
        width: spacing.$3_5,
      }}
    >
      {buttonText}
    </ActionButton>
  );
};
